// Arama sonucunda eslesen kismi <mark> ile isaretler; metin once kacislanir, v-html ile guvenle basilir
const escapeHtml = (s) => String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const highlight = (text, query) => {
    const safe = escapeHtml(text);
    const q = String(query || "").trim();
    if (q.length < 2) return safe;
    return safe.replace(new RegExp(`(${escapeRe(escapeHtml(q))})`, "gi"), "<mark>$1</mark>");
};

// Uzun aciklamadan eslesmenin cevresini keser; eslesme yoksa bastan
export const snippet = (text, query, size = 90) => {
    const plain = String(text || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    if (plain.length <= size) return plain;
    const i = query ? plain.toLowerCase().indexOf(String(query).trim().toLowerCase()) : -1;
    const start = i > 30 ? i - 30 : 0;
    return (start ? "…" : "") + plain.slice(start, start + size).trim() + "…";
};



// WEBPACK FOOTER //
// ./src/utils/shell/highlight.js